import React, {Component} from 'react';
import './extras.css';
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import faGitHub from '@fortawesome/fontawesome-free-brands/faGithub'
import faLinkedIn from '@fortawesome/fontawesome-free-brands/faLinkedin'
import faStackOverflow from '@fortawesome/fontawesome-free-brands/faStackOverflow'

class Name extends Component {
  render() {
    return (
      <div className='Name'>
        <div className='Name-subtitle'>Marcelo G. A. Morales Padilla</div>
        <div className='Name-sub'>
          <div className='Name-prefix'>a.k.a.</div>
          <div className='Name-title'>MAMGUI</div>
        </div>
      </div>
    );
  }
}

class Info extends Component {
  render() {
    return (
      <div className='Info'>
        <div className='Info-link'>
          <a href="https://www.linkedin.com/in/mamgui/">
            <FontAwesomeIcon icon={faLinkedIn} size="2x"/>
          </a>
          <a href="https://github.com/Mamgui/">
            <FontAwesomeIcon icon={faGitHub} size="2x"/>
          </a>
          <a href="https://stackoverflow.com/users/6031289">
            <FontAwesomeIcon icon={faStackOverflow} size="2x"/>
          </a>
        </div>
        <div className='Info-prop'>Computer engineer</div>
        <div className='Info-prop'>Entrepreneur</div>
        <div className='Info-prop'>Designer</div>
      </div>
    );
  }
}

export {Name, Info};


// WEBPACK FOOTER //
// ./src/extras.js